import { ThemeProps as Prop, ColorProfiles, Components } from '@powdr/constants';

export const defaultTheme = {
  [ColorProfiles.BASE]: {
    [Prop.BACKGROUND]: '#FFFFFF',
    [Prop.HEADER]: '#333F48',
    [Prop.CONTENT]: '#333F48',
    [Prop.LINK_TXT]: '#5437E5',
    [Prop.LINK_TXT_HOVER]: '#016A93',
    [Prop.BTN_BG]: '#5437E5',
    [Prop.BTN_TXT]: '#FFFFFF',
    [Prop.BTN_BG_HOVER]: '#016A93',
    [Prop.BTN_TXT_HOVER]: '#ffffff',
    [Prop.BTN_BG_ACTIVE]: '#016A93',
    [Prop.BTN_TXT_ACTIVE]: '#ffffff',
    [Prop.BTN_BG_INACTIVE]: '#333F48',
    [Prop.BTN_TXT_INACTIVE]: '#ffffff',
    [Prop.ELEMENT]: '#5437E5',
    [Prop.ELEMENT_TXT]: '#FFFFFF',
    [Prop.BORDER]: '#848484',
    [Prop.ICON]: '#5437E5',
    [Prop.ICON_HOVER]: '#016A93',
  },
  [ColorProfiles.PRIMARY]: {
    [Prop.BACKGROUND]: '#5437E5',
    [Prop.HEADER]: '#FFFFFF',
    [Prop.CONTENT]: '#FFFFFF',
    [Prop.LINK_TXT]: '#016A93',
    [Prop.LINK_TXT_HOVER]: '#B5B8BA',
    [Prop.BTN_BG]: '#FFFFFF',
    [Prop.BTN_TXT]: '#5437E5',
    [Prop.BTN_BG_HOVER]: '#016A93',
    [Prop.BTN_TXT_HOVER]: '#FFFFFF',
    [Prop.BTN_BG_ACTIVE]: '#016A93',
    [Prop.BTN_TXT_ACTIVE]: '#FFFFFF',
    [Prop.BTN_BG_INACTIVE]: '#016A93',
    [Prop.BTN_TXT_INACTIVE]: '#FFFFFF',
    [Prop.ELEMENT]: '#016A93',
    [Prop.ELEMENT_TXT]: '#FFFFFF',
    [Prop.BORDER]: '#FFFFFF',
    [Prop.ICON]: '#FFFFFF',
    [Prop.ICON_HOVER]: '#016A93',
  },
  [ColorProfiles.SECONDARY]: {
    [Prop.BACKGROUND]: '#B5B8BA',
    [Prop.HEADER]: '#FFFFFF',
    [Prop.CONTENT]: '#FFFFFF',
    [Prop.LINK_TXT]: '#016A93',
    [Prop.LINK_TXT_HOVER]: '#5437E5',
    [Prop.BTN_BG]: '#5437E5',
    [Prop.BTN_TXT]: '#FFFFFF',
    [Prop.BTN_BG_HOVER]: '#016A93',
    [Prop.BTN_TXT_HOVER]: '#FFFFFF',
    [Prop.BTN_BG_ACTIVE]: '#FFFFFF',
    [Prop.BTN_TXT_ACTIVE]: '#5437E5',
    [Prop.BTN_BG_INACTIVE]: '#FFFFFF',
    [Prop.BTN_TXT_INACTIVE]: '#5437E5',
    [Prop.ELEMENT]: '#FFFFFF',
    [Prop.ELEMENT_TXT]: '#016A93',
    [Prop.BORDER]: '#FFFFFF',
    [Prop.ICON]: '#FFFFFF',
    [Prop.ICON_HOVER]: '#016A93',
  },
  [ColorProfiles.TERTIARY]: {
    [Prop.BACKGROUND]: '#016A93',
    [Prop.HEADER]: '#FFFFFF',
    [Prop.CONTENT]: '#FFFFFF',
    [Prop.LINK_TXT]: '#5437E5',
    [Prop.LINK_TXT_HOVER]: '#e8f5fa',
    [Prop.BTN_BG]: '#5437E5',
    [Prop.BTN_TXT]: '#FFFFFF',
    [Prop.BTN_BG_HOVER]: '#B5B8BA',
    [Prop.BTN_TXT_HOVER]: '#FFFFFF',
    [Prop.BTN_BG_ACTIVE]: '#5437E5',
    [Prop.BTN_TXT_ACTIVE]: '#333F48',
    [Prop.BTN_BG_INACTIVE]: '#5437E5',
    [Prop.BTN_TXT_INACTIVE]: '#333F48',
    [Prop.ELEMENT]: '#5437E5',
    [Prop.ELEMENT_TXT]: '#FFFFFF',
    [Prop.BORDER]: '#5437E5',
    [Prop.ICON]: '#FFFFFF',
    [Prop.ICON_HOVER]: '#e8f5fa',
  },
  [ColorProfiles.QUATERNARY]: {
    [Prop.BACKGROUND]: '#292625',
    [Prop.HEADER]: '#5437E5',
    [Prop.CONTENT]: '#FFFFFF',
    [Prop.LINK_TXT]: '#5437E5',
    [Prop.LINK_TXT_HOVER]: '#016A93',
    [Prop.BTN_BG]: '#5437E5',
    [Prop.BTN_TXT]: '#FFFFFF',
    [Prop.BTN_BG_HOVER]: '#016A93',
    [Prop.BTN_TXT_HOVER]: '#FFFFFF',
    [Prop.BTN_BG_ACTIVE]: '#016A93',
    [Prop.BTN_TXT_ACTIVE]: '#FFFFFF',
    [Prop.BTN_BG_INACTIVE]: '#ffffff',
    [Prop.BTN_TXT_INACTIVE]: '#8BCCDC',
    [Prop.ELEMENT]: '#5437E5',
    [Prop.ELEMENT_TXT]: '#FFFFFF',
    [Prop.BORDER]: '#FFFFFF',
    [Prop.ICON]: '#797979',
    [Prop.ICON_HOVER]: '#5437E5',
  },

  [Components.COPYRIGHT]: {
    [Prop.BACKGROUND]: '#5437E5',
    [Prop.LINK_TXT]: '#ffffff',
  },

  [Components.FOOTER]: {
    [Prop.HEADER]: '#FFFFFF',
  },

};
